/* global jQuery COMPONENTS */

COMPONENTS.ComponentHotspot = (function ($) {
  function ComponentHotspot () {
    this.$component = $('[data-ecs-component="component-hotspot"]')
    this.$slider = this.$component.find('[data-ecs-components-control="hotspot-slider"]')
    this.$hotspotButtons = this.$component.find('button[data-ecs-hotspot-linkbutton]')
  }

  ComponentHotspot.prototype.init = function () {
    const component = this
    const utility = new COMPONENTS.Utility()

    if (component.$slider.length >= 1) {
      // hotspot slider on page, init
      const sliderVars = utility.getSliderVars(1, null, true, false, true, false)
      $slider = component.$slider.slick(sliderVars)

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        component.$hotspotButtons.removeClass('ecs_active')
        component.$component.find('[data-ecs-hotspot-linkbutton="' + nextSlide + '"]').addClass('ecs_active')
      })

      component.$hotspotButtons.click(function() {
        console.log('A hotspot has been clicked: ' + $(this).attr('data-ecs-hotspot-linkbutton'))
        $slider.slick('slickGoTo', $(this).attr('data-ecs-hotspot-linkbutton'))
      })
    }
  }

  return ComponentHotspot
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentHotspot = new COMPONENTS.ComponentHotspot()
  COMPONENTS.ComponentHotspot.init()
})
